import configureStore from "./configureStore"

const { persistor, store } = configureStore()

export { persistor, store }
